/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../Router/all_routes";
import { bucketObj } from "../../environment";
import { Editor } from '@tinymce/tinymce-react';
import moment from "moment";
// import imageCompression from 'browser-image-compression'; 
import carYears from "../../core/json/carsTenent/carYears.json";
// import carColors from "../../core/json/carsTenent/carColors.json";
import currencies from "../../core/json/carsTenent/currencies.json";
import carFeatures from '../../core/json/carsTenent/features.json';
// eslint-disable-next-line no-unused-vars
import ImageWithBasePath, {uploadImageNew} from "../../core/img/imagewithbasebath";
import { formatToLocalDateTime } from '../../plugins/helper';
import { APIgetPublicUsers } from "../../api/settings.ts";
import {
  ArrowLeft,
  ChevronDown,
  ChevronUp,
  Info,
  LifeBuoy,
  PlusCircle,
  X,
} from "feather-icons-react/build/IconComponents";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import AddVariation from "./addVariation";
import AddVariationAuc from "./addVariationAuc";

import axios from "axios";
import {setToogleHeader, set_store_list, set_supplier_list, set_variant_list} from "../../core/redux/action";
import Spinner from "../loader/spinner";
import { useNavigate } from "react-router-dom";
import { APIgetStores } from "../../api/settings.ts";

const AddProduct = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");

  const tenantId = localStorage.getItem("tenantId") || null;
  const allowedTenantIds = ["n4Xc96g6qyNcrq5dD", "jNrhXAynhAbQkrj8Y", "8wNWEtTEdgoywriNX"];
  const isAllowedTenant = allowedTenantIds.includes(tenantId);

  const choose = t?.[l]?.["choose"]
  const [customers, setCustomers] = useState([]);
  const [fullCustData, setFullCustData] = useState([]);
  
  const navigate = useNavigate();
  
  const getStoreApi = async () => {
    const res = await APIgetStores({});
    if (res?.response?.stores) {
      const storeData = res.response.stores.reverse();
      const storeOptions = storeData.map((store) => ({
        name: store.title,
        _id: store._id,
        storeCode: store.storeNumber, // Store code
      }));
      dispatch(set_store_list(storeOptions));
    }
  };

  const [product, setProduct] = useState({})
  // const [check, setCheck] = useState(false)
  const [enabled, setEnabled] = useState(false)
  const [imageLoading] = useState(0)
  const [imageData, setImageData] = useState([])
  const [units, setUnits] = useState([])

  const [filteredVariants, setFilteredVariants] = useState([]);
  const [generalProductType, setGeneralProductType] = useState("normal"); // Default to "normal"


    const categoryList = useSelector((state) => state.category_list || []);

    const filteredCategories = categoryList
      // .filter((itm) => itm.tenantid == (tenantId === "n4Xc96g6qyNcrq5dD" ? tenantId : null))
      .filter((itm) => (isAllowedTenant ? itm.tenantid == tenantId : itm.tenantid == null))
      .map((itm) => ({
        label: t?.[l]?.[itm._id] || itm.name,
        value: itm._id
      }));
    
    const category = [{ label: choose, value: "choose" }, ...filteredCategories];
    const currencys = [{ label: choose, value: "choose" }, ...currencies];

const dropdownList = useSelector((state) => state.dropdowns_list || []);
//identifier
const modelList = dropdownList.filter((itm) => itm.identifier == "model") 

useEffect(() => {
  if (!product?.subCategoryId) return;

  const subCatId = String(product.subCategoryId);

  const modelsForSubCat = (modelList ?? [])
    .filter(m => String(m?.id) === subCatId)
    .map(itm => {
      const raw = itm?.value;
      if (raw == null) return null; // skip items missing value

      const key = String(raw);
      const translated = t?.[l]?.[key]; // lookup may be undefined

      return {
        label: translated != null && translated !== '' ? String(translated) : key,
        value: key,
      };
    })
    .filter(Boolean); // remove nulls

  setFilteredModels([{ label: choose, value: 'choose' }, ...modelsForSubCat]);
}, [product?.subCategoryId, modelList, t, l, choose]);


// useEffect(() => {
//   if (product?.subCategoryId) {
//     // 2. Set models for selected sub category
//     const modelsForSubCat = (modelList || [])
//       .filter(m => m.id === product.subCategoryId)
//       .map(itm => ({
//         label: t?.[l]?.[itm.value].toString() || itm.value.toString(),
//         value: itm.value.toString()
//       }));

//     setFilteredModels([
//       { label: choose, value: "choose" },
//       ...modelsForSubCat
//     ]);
//   }
// }, [product?.subCategoryId, modelList, t, l]);



const carColor = dropdownList.filter((itm) => itm.identifier == "color") 
const countryOptions = dropdownList.filter((itm) => itm.identifier == "countries") 
const popularCountriesOptions = countryOptions.map((country) => ({
  label: t[l]?.[country.id] || country.id,
  value: country.id,
}));
const [filteredModels, setFilteredModels] = useState([]);

// const model = [
//   { label: choose, value: "choose" },
//   ...modelList.map((itm) => ({
//     label: t?.[l]?.[itm.value] || itm.value,
//     value: itm.value
//   }))
// ];
const carColors = [
  { label: choose, value: "choose" },
  ...carColor.map((itm) => ({
    label: t?.[l]?.[itm.value] || itm.value,
    value: itm.value
  }))
];

  const getCustomersData = async () => {
  try {
    const res = await APIgetPublicUsers({});
    console.log("res?.response", res?.response);
    if (res?.response) {
      setFullCustData(res.response);
      const options = res.response.map((item) => {
        const { fullName, firstName, lastName } = item.profile || {};
        const name = fullName || `${firstName} ${lastName?lastName:""}` || "Unnamed";
        return {
          value: item._id, // Assuming _id is unique identifier
          label: `${name.trim()} (${item.email || "No Email"})`,
        };
      });
      setCustomers(options); // Make sure `customers` state stores formatted options
    }
  } catch (error) {
    console.log(error);
  }
};

 useEffect(() => {
  getCustomersData();
}, []);
  const carDrivesJson = [
    { "value": "2wd" },
    { "value": "4wd"}
  ];

  const carDrives = [
    { label: choose, value: "choose" },
    ...(carDrivesJson ? carDrivesJson.map((itm) => ({ 
      label: t?.[l]?.[itm.value] || itm.value,
      value: itm.value
    })) : [])
  ];
  
  const subcategory = useSelector((state) => state.subcategory_list || []);


  const [subCatOpts, setSubCatOpts] = useState([{label: choose, value: "choose"}])
  const supplier = useSelector((state) => [{label: choose, value: "choose"}].concat(state.supplier_list?.map((itm) => { return {label: itm.name, value: itm._id}})));
  const store = useSelector((state) => [{label: choose, value: "choose"}].concat(state.store_list?.map((itm) => { return {label: itm.name, value: itm._id}})));
  
  const variant = useSelector((state) => [{label: choose, value: "choose"}].concat(state.variant_list?.map((itm) => { return {label: itm.name, value: itm._id, attributes: itm.attributes,customized: itm.customized}})));
  const [attributes, setAttributes] = useState([{label: choose, value: "choose"}])
  const data = useSelector((state) => state.toggle_header);
  const handleRemoveProduct = (name, index) => {
    setImageData(prevState => ({
      ...prevState,
      [name]: ""
    })); 
    
    let imgs1 = JSON.parse(JSON.stringify(product.imgUrls.filter((_,n) => n!== index)))
    setProduct(prevState => ({
      ...prevState,
      // ["images"]: imgs,
      ["imgUrls"]:imgs1,
    }));
  };
  const handleVariantsChange = (newVariants) => {
    console.log('newVariants',newVariants);
    setFilteredVariants(newVariants);
  };
  const prodData = useSelector((state) => state.product_edit)
  console.log("prodDataprodData",prodData);
  useEffect(() => {
    if (prodData?.viewOnly === true) {
      setEnabled(true);
      console.log("enabled", true);
    }
  }, [prodData?.viewOnly]);
  
  let productAttributes;
  if(prodData?.productAttributes)
  {
    productAttributes = prodData?.productAttributes?.map(item => {
    // Dynamically build 'variant' by joining attribute keys
    const variant = item.attributes.map(attr => Object.keys(attr)[0].charAt(0).toUpperCase() + Object.keys(attr)[0].slice(1)).join('|');
        
    // Dynamically build 'attribute' by joining attribute values
    const attribute = item.attributes.map(attr => Object.values(attr)[0]).join('|');

      return {
          sku: item.sku,
          variant: variant,
          attribute: attribute,
          imgUrls: item.imgUrls || undefined,
          price: item.price || undefined,
          discountType: item.discountType || undefined,
          discountValue: item.discountValue || undefined,
          weight: item.weight || undefined,
          qty: generalProductType=="bid"?1:undefined,
          expiry: item.expiry || undefined,
//auction
          aucStartPrice: Number(item.aucStartPrice) || undefined,
          aucIncrement: Number(item.aucIncrement) || undefined,
          aucSD: item.aucSD || undefined,
          aucED: item.aucED || undefined,
          bidStatus: item.bidStatus || undefined,

      };
    });
  }
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  async function handleFileUpload(event) {
    try {
      if (event.target.files.length) {
        const file = event.target.files[0];
  
        // Check the file size
        if (file.size > 26214400) { // 25 MB(5242880)
          alert(t?.[l]?.["file_size_exceeds_25_mb_limit"] || "File size exceeds 25 MB limit");
          event.target.value = ''; // Clear the file input
          return;
        }
  
        const isImage = file.type.startsWith("image/");
        const isVideo = file.type.startsWith("video/");
  
        let uploadedFileName;
  
        if (isImage) {
          // Image compression options
          // const options = {
          //   maxSizeMB: 1,
          //   maxWidthOrHeight: 500,
          //   useWebWorker: true,
          // };
          const compressedFile = file;//await imageCompression(file, options);
          uploadedFileName = await uploadImageNew(compressedFile,product.categoryId || "product",'img');
        } else if (isVideo) {
          uploadedFileName = await uploadImageNew(file,product.categoryId || "product",'video'); // Upload video without compression
        } else {
          alert("Unsupported file type.");
          event.target.value = '';
          return;
        }
  
        event.target.value = ''; // Reset input
  
        let imgs = JSON.parse(JSON.stringify(product?.imgUrls || []));
        imgs.push(uploadedFileName);
  
        setProduct(prevState => ({
          ...prevState,
          imgUrls: imgs
        }));
      }
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  }
  
  const goBack = () => {
    navigate("/product-list")
  }
  const [productType, setProductType] = useState("single");
  //start bidding
  const [auctionDetails, setAuctionDetails] = useState({
    aucStartPrice: "",
    aucIncrement: "",
    aucSD: getDefaultStartDateTime(),
    aucED: getDefaultEndDateTime(),
    bidStatus: "active",
  });
  function getDefaultStartDateTime() {
    const now = new Date();
const formattedDate = now.getFullYear() + '-' 
    + String(now.getMonth() + 1).padStart(2, '0') + '-'
    + String(now.getDate()).padStart(2, '0') + 'T'
    + String(now.getHours()).padStart(2, '0') + ':'
    + String(now.getMinutes()).padStart(2, '0');

return formattedDate;

    // const now = new Date();
    // return now.toISOString().slice(0, 16); // Format as 'YYYY-MM-DDTHH:mm'
  }

  function getDefaultEndDateTime() {
    const fortomorrow = new Date();
    const now = new Date(fortomorrow);
    const formattedDate = now.getFullYear() + '-' 
    + String(now.getMonth() + 1).padStart(2, '0') + '-'
    + String(now.getDate()).padStart(2, '0') + 'T'
    + String(now.getHours()).padStart(2, '0') + ':'
    + String(now.getMinutes()).padStart(2, '0');

return formattedDate;
  }
  const handleAuctionDetailsChange = (e) => {
    const { name, value } = e.target;

    setAuctionDetails((prev) => {
      const updatedDetails = { ...prev, [name]: value };
      return updatedDetails;
    });
  };
  //end bidding

  const handleProductTypeChange = (e) => {
    const selectedType = e.target.value;
    setProductType(selectedType);

    if (selectedType === "single" || selectedType === "variable" || selectedType === "custom") {
      handleInputChange({ target: { name: "variantId", value: "" } });
      handleInputChange({ target: { name: "variantName", value: "" } });
      handleInputChange({ target: { name: "attribute", value: [] } });
      setAttributes([{ label: choose, value: "choose" }]);
    }
  };

  const submit= async (event) => {
    const form = event.currentTarget;
    event.preventDefault()
    event.stopPropagation()
    try {
      if(form?.checkValidity()) {
        let selectedStore = store?.find(s => s.value === product.storeId) || { label: product.storeName };
        let selectedStoreName = selectedStore.label;
        if(product.pStatus == null)
          product.pStatus = "active"
        if(product.carYear)
        {
          product.carYear = parseInt(product.carYear)
        }
        if(!product?.unit)
          product.unit = units[0].value;
        
        if (generalProductType === "bid" && productType =="single" && (!auctionDetails.aucStartPrice || !auctionDetails.aucIncrement || !auctionDetails.aucSD || !auctionDetails.aucED)) {
          alert("Please fill all auction details.");
          return;
        }

       
        // Create a new product object to avoid direct mutation
        const updatedProduct = {
          ...product,
          storeName: selectedStoreName,
          productType: productType,
          generalProductType:generalProductType
        };

         // Add auctionDetails if generalProductType is "bid"
        if (generalProductType === "bid"  && productType =="single") {
          
          if (!validateAuctionDates(auctionDetails, -1))
          {
            return false;
          }
        
          
          updatedProduct.aucStartPrice = Number(auctionDetails.aucStartPrice) || "";
          updatedProduct.aucIncrement = Number(auctionDetails.aucIncrement) || "";
          updatedProduct.aucSD = auctionDetails.aucSD ? new Date(auctionDetails.aucSD).getTime() : null;
          updatedProduct.aucED = auctionDetails.aucED ? new Date(auctionDetails.aucED).getTime() : null;
          updatedProduct.bidStatus = auctionDetails.bidStatus || "inactive"; // Default to inactive if not set
          updatedProduct.qty = generalProductType=="bid"?1:undefined;
          
            
        }
        if(productType =="single" && isAllowedTenant && !updatedProduct._id)
        updatedProduct.qty = 1;

        // Iterate over the attribute array in obj1
        if(updatedProduct?.attribute && updatedProduct?.productType == 'custom')
        {
          let customizedData = {};
          updatedProduct?.attribute?.forEach(attr => {
            customizedData[attr.value.trim()] = "";
          });
          updatedProduct.customizedData = customizedData;
        }

        if(filteredVariants && filteredVariants.length>0)
          {
            console.log('filteredVariants on submit',filteredVariants)
            const productAttributes = filteredVariants?.filter(
              (variant) => variant && variant.variant !== null && variant.price !== ""
            );
            let i=0;
            let j=0;
            const productAttributes2 =  productAttributes.map(attr => {
              const variantKeys = attr.variant.split('|');
              const attributeValues = attr.attribute.split('|');
            
              // Build the attributes array dynamically
              const attributes = variantKeys.map((key, index) => ({
                  [key.toLowerCase()]: attributeValues[index] || "Unknown"  // Default "Unknown" if missing value
              }));
              if (!validateAuctionDates(attr,i))
              {
                j++;
                return false;
              }
              i++;
              return {
                  sku: attr.sku,
                  attributes,
                  imgUrls: attr?.imgUrls?.length ? attr.imgUrls : [],
                  price: attr.price,
                  discountType: attr.discountType || "percentage",
                  discountValue: attr.discountValue || undefined,
                  weight: attr.weight ? `${attr.weight}` : undefined, // Default weight if empty
                  // unit: attr.unit ? `${attr.unit} pcs` : undefined, //KG
                  
                  qty: generalProductType=="bid"?1:undefined,

                  expiry: attr.expiry?attr.expiry:undefined,

                  aucStartPrice: Number(attr.aucStartPrice) || undefined,
                  aucIncrement: Number(attr.aucIncrement) || undefined,
                  aucSD: attr.aucSD ? new Date(attr.aucSD).getTime() : undefined,
                  aucED: attr.aucED ? new Date(attr.aucED).getTime() : undefined,
                  bidStatus: attr.bidStatus?attr.bidStatus:"active",
              };
            });
            console.log("productAttributes2", productAttributes2);
            // product.productAttributes = productAttributes2;
            if(j>0)
              return;
            const updatedProduct2 = {
              ...updatedProduct,
              productAttributes:productAttributes2,
            };

            console.log("product", product);
            if(product?.variantId)
            delete product?.variantId;
            if(product?.variantName)
             delete product.variantName;
            if(product?.attribute)
            delete product?.attribute;

            if(updatedProduct2.productType == "single")
              {
                if(updatedProduct2.productAttributes)
                  updatedProduct2.productAttributes = [];
                if(updatedProduct2.customizedData)
                  updatedProduct2.customizedData = null
              }
              else if(updatedProduct2.productType == "variable")
              {
                if(updatedProduct2.customizedData)
                  updatedProduct2.customizedData = null
                //"custom"}variable
              }
              else
              {
              if(updatedProduct2.productAttributes)
                updatedProduct2.productAttributes = [];
              }

           

              if(isAllowedTenant )
                {
                  updatedProduct2.tennantType = tenantId; 
                }
              

              await axios.post('addproduct2/', updatedProduct2);
          }
          else 
          {
            delete updatedProduct.productAttributes;
            console.log('updatedProduct',updatedProduct);

            if(updatedProduct.productType == "single")
            {
              if(updatedProduct.productAttributes)
                updatedProduct.productAttributes = [];
              if(updatedProduct.customizedData)
                updatedProduct.customizedData = null
            }
            else if(updatedProduct.productType == "variable")
            {
              if(updatedProduct.customizedData)
                updatedProduct.customizedData = null
              //"custom"}variable
            }
            else
            {
              if(updatedProduct.productAttributes)
                updatedProduct.productAttributes = [];
            }
           
            if(isAllowedTenant )
            {
             updatedProduct.tennantType = tenantId; 
            }
           console.log("updatedProduct.status",updatedProduct.status);
            console.log("updatedProduct.pStatus",updatedProduct.pStatus);
            if (
              isAllowedTenant &&
              // ["showprice", "reserveproduct", "soldout"].includes(updatedProduct.pStatus)
              ["reserveproduct", "soldout"].includes(updatedProduct.pStatus)
            ) 
            {
               const chassis1 = updatedProduct.chassisNumber;
              if (
                !chassis1 ||                         // missing or empty
                chassis1.length < 5 ||               // less than 5
                chassis1.length > 17 ||              // more than 17
                chassis1.includes("*")               // contains *
              ) {
                  alert("Chassis number must be between 5 and 17 characters and must not include '*'.");
                  return false;
                }
            }
            
            if ((isAllowedTenant ) && updatedProduct.customerId) {
              const chassis = updatedProduct.chassisNumber;
// customerId
              if (
                !chassis ||                         // missing or empty
                chassis.length < 5 ||               // less than 5
                chassis.length > 17 ||              // more than 17
                chassis.includes("*")               // contains *
              ) {
                  alert("Chassis number must be between 5 and 17 characters and must not include '*'.");
                  return false;
                }
//nabeel
console.log("updatedProduct.customerId",updatedProduct.customerId);

              if(isAllowedTenant && updatedProduct.customerId )//updatedProduct.ordPlaced != true)
              {
                
                updatedProduct.pStatus = "reserveproduct";
                const res = await axios.post('addproduct2/', updatedProduct);
                if(res)
                {
                  const customer  = fullCustData?.find(option => option._id === product.customerId);
                  console.log("customer",customer);
                
                  const payload = {
                    "saleStatus": "pending",
                    "paymentType": "COD",
                    "transitStatus": "Packing",
                    "policy": true,
                    "shippingCost": 0,
                    "lang": "en",
                    "currency": "USD",
                    "conversionRate": 1,
                    "deliveryType": "delivery",
                    "storeId": product.storeId,

                    "billingAddress": null,
                    "sameBillingDetail": true,
                    "customerId": customer?._id || undefined,
                    "shippingAddress": {
                        "contactNo": customer.profile?.phoneNumber || undefined,//"92132131233423",
                        "email": customer.email || undefined,//"nabeelrehanpnc@gmail.com",
                        "name":(customer?.profile?.firstName || customer?.profile?.lastName)
                        ? `${customer.profile?.firstName || ''} ${customer.profile?.lastName || ''}`.trim()
                        : undefined,//"Nabeel Rehan",
                        "country": customer.shippingAddress?.country || undefined,//"Pakistan",
                        "state": customer.shippingAddress?.state || undefined,//"Sargodha",
                        "area": customer.shippingAddress?.area || undefined,//"Sargodha",
                        "zipCode": customer.shippingAddress?.zipCode || undefined,//"40100",
                        "address": customer.shippingAddress?.address || undefined,//"23-A Aziz bhatti town"
                    },
                    "pickupStoreAddress": "",
                    "pickupOption": "",
                    "pickUpDate": "",
                    "pickUpTime": "",
                    "pickupStoreName": "",
                    "recurringPayment": false,
                    "products": [
                        {
                            "_id": product._id,//"7mo6YY7XNZERRRoL4",
                            "name": product.name,//"TOYOTA Camry 2002 Silver",
                            "customizedData": {},
                            "discountValue": product.discountValue || 0,
                            "price": ""+product.price,//"3278",
                            "tennantId": product.tennantId,//"n4Xc96g6qyNcrq5dD",
                            "userId": product.userId,//"NTc72jF34Qhvnta6i",
                            "quantity": 1,

                            "carYear": parseInt(product.carYear),
                            "cc": product.cc,
                            "millage": product.millage,
                            "carColor": product.carColor,
                            "carDrive": product.carDrive,

                            "subCategoryName": product.subCategoryName || "",
                            "unitPrice": "" + product.price,
                            "totalCost": Number(product.price),
                            "attributeValue": {},
                            "totalDiscountPrice": 0,
                            "status": "true",
                            "chassisNumber": product.chassisNumber
                        }
                    ],
                    "chassisNumbers": [product.chassisNumber],
                    "createdBy": {
                      "id": customer?._id || undefined,
                      "tennantId": tenantId || "123",
                      "name": (customer?.profile?.firstName || customer?.profile?.lastName)
                        ? `${customer.profile?.firstName || ''} ${customer.profile?.lastName || ''}`.trim()
                        : undefined,
                  },
                    "status": "true",
                    "grossCount": 1,
                    "grossTotal": Number(product.price)
                  }
                
                  console.log("payload",payload);
                  try {
                    
                    const res =  await axios.post('addupdateorder/', payload);
                    console.log("res",res);
                  
                  }
                  catch(e) {
                    console.log(e)
                    return false;
                  }
                }
                
              }
            }
            else
              await axios.post('addproduct2/', updatedProduct);
          }
        goBack()
      }
    } catch(e) {
      console.log(e)
      return false;
    }
    

    return false;
  }
  useEffect(() => {
    async function fetchImages() {
      if(typeof product.imgUrls == "object") {
        setImageData(product.imgUrls)

      }
    }
    fetchImages()
  }, [product])

  useEffect(() => {
    if(prodData) {
      if(prodData.productType) {
       
        setProductType(prodData.productType)
      }
    if (prodData.generalProductType) {
      setGeneralProductType(prodData.generalProductType);
    }

    if (prodData.categoryId) {
      const filteredSubcategories = subcategory?.filter(itm => itm.categoryId === prodData.categoryId);
      setSubCatOpts([
        { label: choose, value: "choose" },
        ...(filteredSubcategories || []).map(itm => ({ value: itm._id, label:t?.[l]?.[itm._id] || itm._id }))
      ]);

      // Set the selected subcategory if it exists
      if (prodData.subCategoryId) {
        setProduct(prevState => ({
          ...prevState,
          subCategoryId: prodData.subCategoryId // Ensure this is set to product state
        }));
      }
    }
    // if(prodData?._id && (!prodData?.attributeValue ||prodData?.attributeValue == ""))
    //     {
    //       setCheck(true); 
    //     }
    //     else  
    //       setCheck(false); 
      if(prodData?.variantId) {
        
        setAttributes([{label: choose, value: "choose"}].concat(variant?.filter((itm) => itm?.value == prodData.variantId)?.[0]?.attributes?.split(",").map((v) => ({value: v, label: v}))));
                          
      }
      setProduct( prodData )
      if (prodData.aucStartPrice) {
        setAuctionDetails((prev) => ({
          ...prev,
          aucStartPrice: Number(prodData.aucStartPrice),
          aucIncrement: Number(prodData.aucIncrement),
          aucSD:  moment.utc(prodData.aucSD).local().format("YYYY-MM-DDTHH:mm"),//new Date(prodData.aucSD).toISOString().slice(0, 16),
          aucED: moment.utc(prodData.aucED).local().format("YYYY-MM-DDTHH:mm"),//new Date(prodData.aucED).toISOString().slice(0, 16),
          bidStatus: prodData.bidStatus,
        }));
      }
      if(typeof prodData.images == "string") {
        setProduct(prevState => ({
          ...prevState,
          ["images"]: JSON.parse(prodData.images || [])
        }));
      }
    }
  }, [prodData,subcategory])
  function validateAuctionDates(auctionDetails, index) {
    const startDate = new Date(auctionDetails.aucSD);
    const endDate = new Date(auctionDetails.aucED);
    const now = new Date();
  
    // Subtract 10 days from the current date
    now.setDate(now.getDate() - 10);
  
    if (startDate < now) {
      if(index == -1)
      {
        alert("Auction Start Date must be at least the current date and time.");
      }
      else
        alert("Auction Start Date must be at least the current date and time at row "+(index+1)+".");
      return false;
    }
  
    if (startDate >= endDate) {
      if(index == -1)
      {
        alert("Auction End Date must be greater than Auction Start Date.");
      }
      else
        alert("Auction End Date must be greater than Auction Start Date at row "+(index+1)+".");
      return false;
    }
  
    return true;
  }
  

  useEffect(() => {
    async function fetchData() {
      try {
        const [ suppliers, variants, unitsList] = await Promise.all([
  
          axios.get("getusersuppliers/"),
          // axios.get("getuserbrands/"),
          axios.get("getuservariants/"),
          axios.get("getunitsbycategory/?category=Weight")
        ]);
        getStoreApi();

        dispatch(set_supplier_list(suppliers.data));
        // dispatch(set_brand_list(brands.data));
        dispatch(set_variant_list(variants.data));

        const unitsData = unitsList.data?.map((itm) => {
            return { label: `${itm.unit} (${itm.abb})`, value: `${itm.unit} (${itm.abb})` };
          //return { label: `${itm.unit} (${itm.abb})`, value: itm._id };
        });
        
        // Check if there is an item with abb = "KG"
        const hasKG = unitsData.some((itm) => itm.label.includes("(KG)"));
        
        // If no item with abb = "KG", add the default
        if (!hasKG) {
          unitsData.push({ label: "Kilogram (KG)", value: 1 });
        }

        setUnits(unitsData);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, [dispatch]);
  const handleInputChange = (e) => {
      //  eslint-disable-next-line no-debugger
    if(e?.target)//categoryId categoryName
    {
    const { name, type, checked } = e.target;
    let { value } = e.target;

    // Corrected regex
//    const restrictedChars = /[%?\\]/g;
const restrictedChars = /[%?\\/]/g;
//    const restrictedChars = /[%?\\\/]/g; 
    if( name == "name")
      value = value.replace(restrictedChars, "");
  
    
    if (name === "weight" && (value > 99999 || value.toString().length>5)) {   
      return; // Prevent setting the value if it exceeds max
    }
    if (type === 'checkbox') {
      setProduct(prevState => ({
        ...prevState,
        [name]: checked
      }));
    } else {
      setProduct(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  }
  };

  const discounttype = [
    { value: "choose", label: choose },
    { value: "percentage", label: t?.[l]?.["percentage"] || "Percentage" },
    // { value: "cash", label: t?.[l]?.["cash"] || "Cash" },
  ];
  return (
    <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
      
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>{t?.[l]?.["new_product"] || "New Product"}</h4>
              <h6>{t?.[l]?.["create_new_product"] || "Create new product"}</h6>
            </div>
          </div>
          <ul className="table-top-head">
            
            <li>
              <div className="page-btn">
                <Link to={route.productlist} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  {t?.[l]?.["back_to_product"] || "Back to Product"}
                </Link>
              </div>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp className="feather-chevron-up" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>
        {/* /add */}
        <form onSubmit={submit}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div
                className="accordion-card-one accordion"
                id="accordionExample"
              >
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-controls="collapseOne"
                    >
                      <div className="addproduct-icon">
                        <h5>
                          <Info className="add-info" />

                          <span>{t?.[l]?.["product_information"] || "Product Information"}</span>
                        </h5>
                        <Link to="#">
                          <ChevronDown className="chevron-down-add" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                    <div className="addservice-info">
                        <div className="row">
                          <div className="col-12">
                            <div className="mb-3 add-product produt-name-type d-flex align-items-center flex-wrap">
                              {/* Product Name */}
                              <div className="col-lg-8 col-12 mb-3">
                                <div className="me-4">
                                  <label className="form-label">{t?.[l]?.["product_name"] || "Product Name"}</label>
                                  <input
                                    type="text"
                                    placeholder={t?.[l]?.["product_name"] || "Product Name"}
                                    className="form-control"
                                    value={product.name}
                                    required
                                    name="name"
                                    onChange={handleInputChange}
                                    disabled={enabled}
                                  />
                                </div>
                              </div>

                              {/* Product Type */}
                              {!isAllowedTenant  &&
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="me-4">
                                    <label className="form-label me-3">{t?.[l]?.["product_type"] || "Product Type"}</label>
                                    <div className="d-flex flex-wrap">
                                      <label className="me-3 d-flex align-items-center">
                                        <input
                                          type="radio"
                                          name="generalProductType"
                                          value="normal"
                                          checked={generalProductType === "normal"}
                                          onChange={(e) => setGeneralProductType(e.target.value)}
                                          disabled={enabled}
                                        />
                                        &nbsp;{t?.[l]?.["normal"] || "Normal"}
                                      </label>

                                      <label className="d-flex align-items-center">
                                        <input
                                          type="radio"
                                          name="generalProductType"
                                          value="bid"
                                          checked={generalProductType === "bid"}
                                          onChange={(e) => setGeneralProductType(e.target.value)}
                                          disabled={enabled}
                                        />
                                        &nbsp;{t?.[l]?.["bid"] || "Bidding"}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>

                      </div>
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className=" mb-3 add-product">
                            <label className="form-label">{t?.[l]?.["store"] || "Store"} *</label>
                            <Select
                              className="select"
                              options={store}
                              placeholder={choose}
                              required
                              value = {
                                store?.filter(option => 
                                  option?.value === product.storeId)
                              }
                              onChange={(v) => {
                                handleInputChange({target: {name: "storeId", value: v.value}})
                                handleInputChange({target: {name: "storeName", value: v.label}})
                              }} />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <div className="add-newplus">
                              <label className="form-label">{t?.[l]?.["supplier"] || "Supplier"}</label>
                            </div>
                            <Select
                              className="select"
                              options={supplier}
                              placeholder={choose}
                              name="discounttype" 
                              value = {
                                supplier?.filter(option => 
                                  option?.value === product.supplierId)
                              }
                              onChange={(v) => {
                                handleInputChange({target: {name: "supplierId", value: v.value}})
                                handleInputChange({target: {name: "supplierName", value: v.label}})
                              }} />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <div className="add-newplus">
                              <label className="form-label">{t?.[l]?.["category"] || "Category"} *</label>
                            </div>
                              <Select
                                className="select"
                                options={category || []} // Default to empty array if category is undefined
                                placeholder={choose}
                                required
                                value={
                                  (category || []).filter(option => 
                                    option?.value === product?.categoryId
                                  ) || []
                                }
                                onChange={(v) => {
                                  if (v?.value) { // Ensure v and v.value are defined
                                    setSubCatOpts([
                                      { label: choose, value: "choose" },
                                      ...((subcategory || []) // Default subcategory to empty array if undefined
                                        .filter(itm => itm?.categoryId === v.value) // Check itm.categoryId
                                        .map(itm => ({
                                          value: itm?._id, // Safeguard itm._id
                                          label:t?.[l]?.[itm._id] || itm._id   // Safeguard itm.name
                                        }))
                                      )
                                    ]);
                                  }
                                  handleInputChange({ target: { name: "categoryId", value: v?.value || "" } });
                                  handleInputChange({ target: { name: "categoryName", value: v?.label || "" } });
                                }}
                              />

                          </div>
                        </div>
                        
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <div className="add-newplus">
                              <label className="form-label">{t?.[l]?.["sub_category"] || "Sub Category"}</label>
                            </div>
                              <Select
                                className="select"
                                options={subCatOpts}
                                placeholder={choose}
                                isDisabled={subCatOpts.length < 2}
                                value={subCatOpts.find(option => option?.value === product.subCategoryId) || null} // Use find instead of filter
                                onChange={(v) => {
                                // Handle subCategory changes
                                handleInputChange({ target: { name: "subCategoryId", value: v.value } });
                                handleInputChange({ target: { name: "subCategoryName", value: v.label } });
                                // ✅ Filter models
                                const modelsForSubCat = modelList
                                  .filter(m => m.id === v.value)
                                  .map(itm => ({
                                    label: t?.[l]?.[itm.value] || itm.value,
                                    value: itm.value
                                  }));

                                setFilteredModels([
                                  { label: choose, value: "choose" },
                                  ...modelsForSubCat
                                ]);

                                
                              }}
                            />
                          </div>
                        </div>
                 
                        {isAllowedTenant &&
                          <>
                      {/* Car Tenant Base */}
                        <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <div className="add-newplus">
                                <label className="form-label">{t?.[l]?.["model"] || "Model"}</label>
                              </div>
                            <Select
                                  className="select"
                                  options={filteredModels || []}
                                  placeholder={choose}
                                  name="modelId"
                                  value={filteredModels.find(option => option?.value === product.modelId) || null}
                                  onChange={(v) => {
                                    handleInputChange({ target: { name: "modelId", value: v?.value || "" } });
                                    handleInputChange({ target: { name: "modelName", value: v?.label || "" } });
                                  }}
                                />

                            </div>
                          </div>

                          {/* Car Tenant Base years*/}
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <div className="add-newplus">
                                <label className="form-label">{t?.[l]?.["year"] || "Year"}</label>
                              </div>
                              <Select
                                className="select"
                                options={carYears || []} // Comes from JSON
                                placeholder={choose}
                                name="carYear"
                                value={carYears.find(option => option?.value === product.carYear) || null}
                                onChange={(v) => handleInputChange({ target: { name: "carYear", value: v?.value || "" } })}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <div className="add-newplus">
                                <label className="form-label">{t?.[l]?.["drive"] || "Drive"}</label>
                              </div>
                              <Select
                                className="select"
                                options={carDrives || []} // Comes from JSON
                                placeholder={choose}
                                name="carDrive"
                                value={carDrives.find(option => option?.value === product.carDrive) || null}
                                onChange={(v) => handleInputChange({ target: { name: "carDrive", value: v?.value || "" } })}
                              />
                            </div>
                          </div>
                          {/* Car Tenant Base millage*/}
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <div className="add-newplus">
                                <label className="form-label">{t?.[l]?.["millage"] || "Millage (KM)"}</label>
                              </div>
                              <input
                                type="number"
                                className="form-control"
                                name="millage"
                                value={product.millage || ""}
                                onChange={handleInputChange}
                                placeholder="Enter millage"
                                min="0"
                              />
                            </div>
                          </div>
                          {/* Car Tenant Base */}
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <div className="add-newplus">
                                <label className="form-label">{t?.[l]?.["color"] || "Color"}</label>
                              </div>
                              <Select
                                className="select"
                                options={carColors || []} 
                                placeholder={choose}
                                name="carColor"
                                value={carColors.find(option => option?.value === product.carColor) || null}
                                onChange={(v) => handleInputChange({ target: { name: "carColor", value: v?.value || "" } })}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <div className="add-newplus">
                                <label className="form-label">{t?.[l]?.["referenceNumber"] || "Reference Number"}</label>
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                name="carID"
                                value={product.carID || ""}
                                onChange={handleInputChange}
                                placeholder={t?.[l]?.["enter_referenceNumber"] || "Enter reference number"}
                              />
                            </div>
                          </div>

                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <div className="add-newplus">
                                <label className="form-label">{t?.[l]?.["date"] || "Date"}</label>
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                name="dateOntaacaa"
                                value={product.dateOntaacaa || ""}
                                onChange={handleInputChange}
                                placeholder={t?.[l]?.["enter_date"] || "Enter date"}
                              />
                            </div>
                          </div>

                          <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <div className="add-newplus">
                              <label className="form-label">{t?.[l]?.["site"] || "Site"}</label>
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              name="site"
                              value={product.site || ""}
                              onChange={handleInputChange}
                              placeholder={t?.[l]?.["enter_site"] || "Enter site"}
                            />
                          </div>
                        </div>

                        

                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <div className="add-newplus">
                              <label className="form-label">{t?.[l]?.["model_code"] || "Model Code"}</label>
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              name="modelCode"
                              value={product.modelCode || ""}
                              onChange={handleInputChange}
                              placeholder={ t?.[l]?.["enter_model_code"] || "Enter model code"}
                            />
                          </div>
                        </div>

                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <div className="add-newplus">
                              <label className="form-label">{t?.[l]?.["transmission"] || "Transmission"}</label>
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              name="tm"
                              value={product.tm || ""}
                              onChange={handleInputChange}
                              placeholder={t?.[l]?.["enter_transmission"] || "Enter Transmission"}
                            />
                          </div>
                        </div>

                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <div className="add-newplus">
                              <label className="form-label">{t?.[l]?.["ext_int"] || "Ext/Int"}</label>
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              name="extInt"
                              value={product.extInt || ""}
                              onChange={handleInputChange}
                              placeholder={t?.[l]?.["enter_ext_int"] || "Enter Ext/Int"}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <div className="add-newplus">
                              <label className="form-label">{t?.[l]?.["seats"] || "Seats"}</label>
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              name="seats"
                              value={product.seats || ""}
                              onChange={handleInputChange}
                              placeholder={t?.[l]?.["enter_seats"] || "Enter Seats"}
                            />
                          </div>
                        </div>
                        {/* Engine Size (after Seats) */}
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <div className="add-newplus">
                              <label className="form-label">{t?.[l]?.["engineSize"] || "Engine Size (cc)"}</label>
                            </div>
                            <input
                              type="number"
                              className="form-control"
                              name="cc"                     // keep backend compatibility
                              value={product.cc || ""}
                              onChange={handleInputChange}
                              placeholder={t?.[l]?.["enter_engineSize"] || "Enter engine size (cc)"}
                              min="0"
                            />
                          </div>
                        </div>
                        

                          <div className="col-lg-12 col-sm-12 col-12">
                            <div className="mb-3 add-product">
                              <div className="add-newplus">
                                <label className="form-label">{t?.[l]?.["show_product_in"] || "Show Product In"}</label>
                              </div>
                              <Select
                                  className="select"
                                  options={popularCountriesOptions}
                                  isMulti // Enable multi-select
                                  value={popularCountriesOptions.filter(option =>
                                    product.showProductInCountries?.includes(option.value)
                                  )}
                                  name="showProductInCountries"
                                  onChange={(selectedOptions) =>
                                      handleInputChange({
                                          target: { name: "showProductInCountries", value: selectedOptions.map(option => option.value) }
                                      })
                                  }
                              />
                            </div>
                          </div>
                          <div className="col-lg-12 col-sm-12 col-12">
                            <div className="mb-3 add-product">
                              <div className="add-newplus">
                                <label className="form-label">{t?.[l]?.["popular_countries"] || "Popular Countries"}</label>
                              </div>
                              <Select
                                  className="select"
                                  options={popularCountriesOptions}
                                  isMulti // Enable multi-select
                                  value={popularCountriesOptions.filter(option =>
                                    product.popularCountries?.includes(option.value)
                                  )}
                                  name="popularCountries"
                                  onChange={(selectedOptions) =>
                                      handleInputChange({
                                          target: { name: "popularCountries", value: selectedOptions.map(option => option.value) }
                                      })
                                  }
                              />
                            </div>
                          </div>

                          {/* Car Features Checkboxes */}
                          <div className="col-12">
                            <div className="mb-4">
                              <label className="form-label fw-semibold">{t?.[l]?.["features"] || "Features"}</label>
                              <div className="row">
                                {carFeatures.map((feature, index) => {
                                  const isChecked = product.features?.includes(feature);
                                  return (
                                    <div className="col-6 col-md-4 col-lg-2 mb-2" key={index}>
                                      <label
                                        className={`form-check custom-check p-2 border rounded shadow-sm h-100 d-flex align-items-center ${isChecked ? "active-feature" : ""}`}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <input
                                          className="form-check-input me-2"
                                          type="checkbox"
                                          checked={isChecked}
                                          onChange={() => {
                                            const updated = isChecked
                                              ? product.features.filter(f => f !== feature)
                                              : [...(product.features || []), feature];
                                            handleInputChange({ target: { name: "features", value: updated } });
                                          }}
                                        />
                                        <span className="form-check-label text-truncate" style={{ maxWidth: "100%", color: "#6c757d" }}>
                                        {t?.[l]?.[feature] || feature}
                                        </span>

                                      </label>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                          </>
                        }
                           <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <div className="add-newplus">
                                <label className="form-label">{t?.[l]?.["currency"] || "Currency"} *</label>
                              </div>
                              <Select
                                className="select"
                                options={currencys || []}
                                placeholder={choose}
                                required
                                name="currency"
                                value={currencys.find(option => option?.value === product.currency) ||  currencys[0]}
                                onChange={(v) =>
                                  handleInputChange({ target: { name: "currency", value: v?.value || "" } })
                                }
                                formatOptionLabel={({ label, flag }) => (
                                  <div style={{ display: "flex", alignItems: "center" }}>
                                    {flag && (<img
                                      src={flag}
                                      alt={label}
                                      style={{ width: 20, height: 15, marginRight: 10, objectFit: "cover" }}
                                    />)}
                                    <span>{label}</span>
                                  </div>
                                )}
                              />

                            </div>
                          </div>
                      </div>
                      <div className="row">
                          <div className="col-lg-12 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <div className="status-toggle modal-status d-flex align-items-center">
                                    <span className="status-label">{t?.[l]?.["featured"] || "Featured"}</span>
                                    <input
                                        type="checkbox"
                                        id="featured"
                                        name="featured"
                                        className="check"
                                        
                                        checked={product.featured} 
                                        onChange={handleInputChange}
                                    />
                                  <label
                                    style={{
                                      marginLeft: l === 'ar' ? '' : '7px',
                                      marginRight: l === 'ar' ? '16px' : '' // Adjust this as needed
                                    }}

                                     htmlFor="featured" className="checktoggle" />


                                </div>
                              </div>
                          </div>
                          
                          <div className="col-lg-12 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                            <div className="status-toggle modal-status d-flex align-items-center">
                                <span className="status-label">{t?.[l]?.["special"] || "Special"}</span>
                                <input
                                    type="checkbox"
                                    id="special"
                                    name="special"
                                    className="check"
                                   
                                    defaultValue={false}
                                    checked={product.special} 
                                    onChange={handleInputChange}
                                />
                                <label  
                                style={{
                                  marginLeft: l === 'ar' ? '' : '15px',
                                  marginRight: l === 'ar' ? '13px' : '' // Adjust this as needed
                                }} htmlFor="special" className="checktoggle" />
                            </div>

                            </div>
                          </div>
                        </div>
                      <div className="col-lg-12">
                        <div className="input-blocks summer-description-box transfer mb-3">
                          <label>{t?.[l]?.["description"] || "Description"}</label>
                          <Editor
                            apiKey="rbsxd1j72b4sitiwca18k9gj58fb2e2cbkl8dvkrhblwut02"
                            init={{
                              height: 300,
                              menubar: false,
                              plugins: [
                                'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                              ],
                    
                              toolbar: 'undo redo | blocks | ' +
                              'bold italic forecolor | alignleft aligncenter ' +
                              'alignright alignjustify | bullist numlist outdent indent | ' +
                              'removeformat | help',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'

                            }}
                            value={product.description}
                            onEditorChange={(content) => handleInputChange({ target: { name: "description", value: content } })}
                          />
                          <p className="mt-1">{t?.[l]?.["maximum_1000_characters"] || "Maximum 1000 Characters"}</p>
                        </div>
                      </div>
                      <div
                                id="collapseThree"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingThree"
                                data-bs-parent="#accordionExample3"
                              >
                                <div className="accordion-body">
                                  <div className="text-editor add-list add">
                                    <div className="col-lg-12">
                                      <div className="add-choosen">
                                        <div className="input-blocks">
                                          <div className="image-upload">
                                            <input type="file" 
                                            accept="image/png,image/jpg,image/gif,image/jpeg,image/svg,video/mp4,video/webm,video/ogg"
                                            onChange={handleFileUpload} />
                                            <div className="image-uploads">
                                              <PlusCircle className="plus-down-add me-0" />
                                              <h4>{t?.[l]?.["add_images_video"] || "Add Images/Video"}</h4>
                                            </div>
                                          </div>
                                          {imageLoading > 0 && <Spinner/>}
                                        </div>
                                        <div className="phone-img-container d-flex flex-wrap gap-2">
 
                                          {imageData && imageData.length > 0 && imageData.map((key, index) => {
                                            const fileUrl = key.startsWith('http') ? key : bucketObj.bucketUrl + bucketObj.objectKey + key;
                                            const isVideo = /\.(mp4|webm|ogg)$/i.test(fileUrl);

                                            return (
                                              <div className="phone-img border rounded p-2" key={index}>
                                                {isVideo ? (
                                                  <video controls 
                                                  className="img-fluid-phone-img" 
                                                  style={{ width: "100%", height: "auto", objectFit: "cover" }}>
                                                    <source src={fileUrl} type={`video/${fileUrl.split('.').pop()}`} />
                                                    Your browser does not support the video tag.
                                                  </video>
                                                ) : (
                                                  <ImageWithBasePath
                                                    src={fileUrl}
                                                    alt={key}
                                                    absolutePath="true"
                                                    className="img-fluid-phone-img"
                                                    style={{ width: "100%", height: "auto", objectFit: "cover" }}
                                                  />
                                                )}

                                                <Link
                                                  to="#"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    handleRemoveProduct(key, index);
                                                  }}
                                                >
                                                  <X className="x-square-add remove-product" />
                                                </Link>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
   
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="accordion-card-one accordion"
                id="accordionExample2"
              >
                <div className="accordion-item">

                  <div className="accordion-header" id="headingTwo">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-controls="collapseTwo"
                    >
                      <div className="text-editor add-list">
                        <div className="addproduct-icon list icon">
                          <h5>
                            <LifeBuoy className="add-info" />
                            <span>{t?.[l]?.["pricing"] || "Pricing"}</span>
                          </h5>
                          <Link to="#">
                            <ChevronDown className="chevron-down-add" />
                          </Link>
                        </div>
                      </div>
                
                    </div>
                  </div>
                 
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample2"
                  >
                    <div className="accordion-body">
                      
                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className="tab-pane fade show active"
                          id="pills-home"
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                        >
                          <div className="row">
                            { !isAllowedTenant  && 
                            <>
                              <div className="col-12">
                                <div className="mb-4">
                                  <label className="form-label">{t?.[l]?.["product_type"] || "Product Type"}</label>
                                  <div className="d-flex align-items-center flex-wrap">
                                    <label className="form-label me-3 d-flex align-items-center" style={{ display: prodData?.productType && prodData?.productType !== "single" ? 'none' : 'inline-block' }}>

                                      <input
                                        type="radio"
                                        name="productType"
                                        value="single"
                                        checked={productType === "single"}
                                        onChange={handleProductTypeChange}
                                        // disabled={prodData?.productType && prodData?.productType !== "single"}
                                        
                                      />
                                      &nbsp;&nbsp; {t?.[l]?.["single_product"] || "Single Product"}
                                    </label>
                                    <label className="form-label me-3 d-flex align-items-center" style={{ display: prodData?.productType && prodData?.productType !== "variable" ? 'none' : 'inline-block' }}>
                                    <input
                                        type="radio"
                                        name="productType"
                                        value="variable"
                                        checked={productType === "variable"}
                                        onChange={handleProductTypeChange}
                                        // disabled={prodData?.productType && prodData?.productType !== "variable"}

                                      />
                                      &nbsp;&nbsp; {t?.[l]?.["variable_product"] || "Variable Product"}
                                    </label>
                                    {/* )} */}
                                    {(generalProductType != "bid") && (
                                    <label className="form-label me-3 d-flex align-items-center"  style={{ display: prodData?.productType && prodData?.productType !== "custom" ? 'none' : 'inline-block' }}>
                                    <input
                                        type="radio"
                                        name="productType"
                                        value="custom"
                                        checked={productType === "custom"}
                                        onChange={handleProductTypeChange}
                                        // disabled={prodData?.productType && prodData?.productType !== "custom"}

                                      />
                                      &nbsp;&nbsp; {t?.[l]?.["custom_product"] || "Custom Product"}
                                      </label>
                                      )}
                                    </div>
                                </div>
                              </div>
                              {productType == "variable" && generalProductType != "bid" && (
                              <AddVariation onVariantsChange={handleVariantsChange} productAttributes = {productAttributes} variants = {variant}/>
                              )}
                              
                              {productType == "variable" && generalProductType === "bid" && (
                              <AddVariationAuc onVariantsChange={handleVariantsChange} productAttributes = {productAttributes} variants = {variant}/>
                              )}
                              
                              {productType == "custom" && (
                                  <div className="row">
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="input-blocks add-product">
                                    <label>{t?.[l]?.["variant"] || "Variant"}</label>

                                      <Select
                                        className="select"
                                        options={
                                          Array.isArray(variant)
                                            ? variant.filter(option =>
                                                option && // Ensure option is defined
                                                (productType === "custom" 
                                                  ? option.customized === true 
                                                  : option.customized === false || option.customized == null)
                                              )
                                            : []
                                        }
                                        placeholder={choose}
                                        value={
                                          Array.isArray(variant)
                                            ? variant.find(option => option && option.value === product.variantId) || null // Use find to get a single option
                                            : null
                                        }
                                        // isDisabled={check}
                                        onChange={(v) => {
                                          if (v.attributes) {
                                            handleInputChange({ target: { name: "attribute", value: [] } });
                                            setAttributes([
                                              { label: choose, value: "choose" },
                                              ...v.attributes.split(",").map((v) => ({ value: v, label: v }))
                                            ]);
                                          }
                                          handleInputChange({ target: { name: "variantId", value: v.value } });
                                          handleInputChange({ target: { name: "variantName", value: v.label } });
                                        }}
                                      />

                                  </div>
                                </div>
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="input-blocks add-product">
                                      <label>{t?.[l]?.["attributes"] || "Attributes"}</label>
                                    
                                    <Select
                                      className="select"
                                      options={attributes}
                                      isMulti
                                      placeholder={choose}
                                      name="discounttype" 
                                      isDisabled={attributes?.length < 2}
                                      value = {product.attribute}
                                      onChange={(v) => {
                                        console.log(v)
                                        handleInputChange({target: {name: "attribute", value: v}})
                                      }} />
                                  </div>
                                </div>
                            
                                </div>
                              )}
                             </>
                            }
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="input-blocks add-product">
                                {isAllowedTenant && tenantId != "jNrhXAynhAbQkrj8Y" ? 
                                <label>{t?.[l]?.["product_price_p"] || "Price"}</label>:
                                
                                <label>{t?.[l]?.["price"] || "Price"}</label>
                                }
                                <input type="number" className="form-control" placeholder={t?.[l]?.["price"] || "Price"} value={product.price} required name="price" onChange={handleInputChange}/>
                              </div>
                            </div>
                            { !isAllowedTenant  && 
                            <>
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="input-blocks add-product">
                                <label>{t?.[l]?.["discount_type"] || "Discount Type"}</label>
                                <Select
                                  className="select"
                                  options={discounttype}
                                  placeholder={choose}
                                  
                                  name="discounttype" 
                                  value = {
                                    discounttype?.filter(option => 
                                      option.value === product.discountType)
                                  }
                                  onChange={(v) => {
                                    handleInputChange({target: {name: "discountType", value: v.value}})
                                  }} />
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="input-blocks add-product">
                                <label>{t?.[l]?.["discount_value"] || "Discount Value"}</label>
                                <input type="number" className="form-control" placeholder={t?.[l]?.["discount_value"] || "Discount Value"} value={product.discountValue} name="discountValue" onChange={handleInputChange}/>
                              </div>
                            </div>
                            </>}
                           
                              <div className="col-lg-4 col-sm-6 col-12">
                                <div className="input-blocks add-product">
                                  <label>{t?.[l]?.["status"] || "Status"} *</label>
                                  <Select
                                    className="select"
                                    required
                                    options={[
                                      { value: 'active', label: t?.[l]?.["active"] || "Active" },
                                      { value: 'inactive', label: t?.[l]?.["inactive"] || "Inactive" },
                                      { value: 'showprice', label: t?.[l]?.["showprice"] || "Show Price" },
                                      // { value: 'reserveproduct', label: t?.[l]?.["reserveproduct"] || "Reserve Product" },
                                      // { value: 'soldout', label: t?.[l]?.["sold_out"] || "Sold Out" }
                                    ]}
                                    placeholder={choose}
                                    styles={{width: "103%"}}
                                    value={
                                      product.pStatus 
                                        ? { value: product.pStatus, label: t?.[l]?.[product.pStatus] || product.pStatus.charAt(0).toUpperCase() + product.pStatus.slice(1) }
                                        : { value: 'active', label: t?.[l]?.["active"] || "Active" }
                                    }
                                    onChange={(v) => {
                                      handleInputChange({ target: { name: 'pStatus', value: v.value } });
                                    }}
                                  />

                                </div>
                              </div>

                              

                            { isAllowedTenant  && 
                              <>
                              <div className="col-lg-4 col-sm-6 col-12">
                                <div className="input-blocks add-product">
                                  <label>
                                    {t?.[l]?.["pnc_purchased"] || "Purchased"}
                                  </label>
                                  <input
                                    type="checkbox"
                                    id="myOwn"
                                    className="me-2"
                                    checked={product.myOwn === true}
                                    onChange={(e) =>
                                      handleInputChange({
                                        target: { name: "myOwn", value: e.target.checked }
                                      })
                                    }
                                  />
                                  
                                </div>
                              </div>
                              </>
                            }



                              { !isAllowedTenant  && 
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="input-blocks add-product" style={{marginLeft: "3%"}}>
                                    <label>{t?.[l]?.["weight"] || "Weight (kg)"}</label>
                                    <div className="input-group" style={{width: "106%"}}>
                                    <div className="input-group-append">
                                        <select className="form-control" name="unit" style={{borderTopRightRadius: "0",borderBottomRightRadius: "0", minHeight: "46px"}} 
                                        //  value={selectedUnit}
                                        //  onChange={handleChange}
                                        disabled>
                                          {units.map((unit, index) => (
                                            <option key={unit.value} value={unit.value} selected={index === 0}>
                                              {t?.[l]?.unit_label || "Kilogram (kg)"}
                                            </option>
                                          ))}
                                        </select>
                                      </div>

                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder= {t?.[l]?.unit_label || "Kilogram (kg)"}
                                        style={{ minHeight: "46px" }}
                                        value={product.weight || ''}
                                        name="weight"
                                        max={99999}
                                        onChange={handleInputChange}
                                      />
                                    
                                    </div>
                                  </div>
                                </div>
                              }
                              
                              {/* Auction Fields */}
                              {generalProductType === "bid" && productType === "single" && (
                                <div className="row">
                                  {/* Auction Start Price */}
                                  <div className="col-lg-4 col-sm-6 col-12">
                                    <div className="input-blocks add-product">
                                      <label>{t?.[l]?.["aucStartPrice"] || "Auction Start Price"} *</label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder={t?.[l]?.["aucStartPrice"] || "Auction Start Price"}
                                        value={auctionDetails.aucStartPrice}
                                        name="aucStartPrice"
                                        onChange={handleAuctionDetailsChange}
                                      />
                                    </div>
                                  </div>

                                  {/* Auction Increment */}
                                  <div className="col-lg-4 col-sm-6 col-12">
                                    <div className="input-blocks add-product">
                                      <label>{t?.[l]?.["aucIncrement"] || "Auction Increment"} *</label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder={t?.[l]?.["aucIncrement"] || "Auction Increment"}
                                        value={auctionDetails.aucIncrement}
                                        name="aucIncrement"
                                        onChange={handleAuctionDetailsChange}
                                      />
                                    </div>
                                  </div>

                                  {/* Auction Start Date */}
                                  <div className="col-lg-4 col-sm-6 col-12">
                                    <div className="input-blocks add-product">
                                      <label>{t?.[l]?.["aucSD"] || "Auction Start Date"} </label>
                                      <input
                                        type="datetime-local"
                                        className="form-control"
                                        value={auctionDetails.aucSD}
                                        name="aucSD"
                                        required
                                        min={formatToLocalDateTime(new Date())} // Use a helper function to format correctly                                    

                                        // onChange={handleAuctionDetailsChange}
                                        onChange={(e) => {
                                          const selectedDate = new Date(e.target.value);
                                          const now = new Date();
                                           // Remove milliseconds and seconds from both dates for accurate comparison
                                          selectedDate.setMilliseconds(0);
                                          selectedDate.setSeconds(0);
                
                                          now.setMilliseconds(0);
                                          now.setSeconds(0);
                                          // Ensure the selected date is not in the past
                                          if (selectedDate < now) {
                                            alert("You cannot select a past date or time.");
                                            e.target.value = ""; // Reset the value
                                            return;
                                          }
                                          handleAuctionDetailsChange(e);
                                        }}
                                      />

                                    </div>
                                  </div>

                                  {/* Auction End Date */}
                                  <div className="col-lg-4 col-sm-6 col-12">
                                    <div className="input-blocks add-product">
                                      <label>{t?.[l]?.["aucED"] || "Auction End Date"} *</label>
                                      <input
                                        type="datetime-local"
                                        className="form-control"
                                        value={auctionDetails.aucED}
                                        name="aucED"
                                        onChange={handleAuctionDetailsChange}
                                      />
                                    </div>
                                  </div>

                                  {/* Bid Status */}
                                  <div className="col-lg-4 col-sm-6 col-12">
                                    <div className="input-blocks add-product">
                                      <label>{t?.[l]?.["bidStatus"] || "Bid Status"} *</label>
                                      <Select
                                        className="select"
                                        required
                                        options={[
                                          { value: "active", label: t?.[l]?.["active"] || "Active" },
                                          { value: "canceled", label: t?.[l]?.["inactive"] || "Inactive" },
                                        ]}
                                        placeholder={t?.[l]?.["choose"] || "Choose"}
                                        value={{
                                          value: auctionDetails.bidStatus,
                                          label:
                                            t?.[l]?.[auctionDetails.bidStatus] ||
                                            auctionDetails.bidStatus.charAt(0).toUpperCase() +
                                              auctionDetails.bidStatus.slice(1),
                                        }}
                                        onChange={(option) =>
                                          handleAuctionDetailsChange({
                                            target: { name: "bidStatus", value: option.value },
                                          })
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div
                className="accordion-card-one accordion"
                id="accordionExample2"
              >
                <div className="accordion-item">
                  <div className="accordion-header" id="headingTwo">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-controls="collapseTwo"
                    >
                      <div className="text-editor add-list">
                        <div className="addproduct-icon list icon">
                          <h5>
                            <LifeBuoy className="add-info" />
                            <span>{t?.[l]?.["sale"] || "Sale"}</span>
                          </h5>
                          <Link to="#">
                            <ChevronDown className="chevron-down-add" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample2"
                  >
                    <div className="accordion-body">
                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className="tab-pane fade show active"
                          id="pills-home"
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                        >
                          <div className="row">
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <div className="add-newplus">
                                  <label className="form-label">{t?.[l]?.["chassis_number"] || "Chassis Number"}</label>
                                </div>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="chassisNumber"
                                  value={product.chassisNumber || ""}
                                  onChange={handleInputChange}
                                  maxLength={18}
                                  placeholder={t?.[l]?.["enter_chassis_number"] || "Enter chassis number"}
                                />
                              </div>
                            </div>
                             {/* Select Customer */}
                            { prodData?._id  && 
                              <div className="col-lg-4 col-sm-6 col-12" >
                                <div className="input-blocks add-product">
                                  <label>{t?.[l]?.["select_customer"] || "Select Customer"}</label>
                                  <Select
                                    className="select"
                                    options={customers}
                                    placeholder={choose}
                                    name="customerId"
                                    value={customers?.find(option => option.value === product.customerId)}
                                    onChange={(v) => {
                                      handleInputChange({ target: { name: "customerId", value: v.value } });
                                    }}
                                  />
                                </div>
                              </div>
                            }
                             {/* Purchase Date */}
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <label className="form-label">{t?.[l]?.["purchase_date"] || "Purchase Date"}</label>
                                <input
                                  type="date"
                                  className="form-control"
                                  name="purchaseDate"
                                  value={product.purchaseDate}
                                  onChange={handleInputChange}
                                />

                              </div>
                            </div>                 
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {!enabled && (
            <div className="col-lg-12">
              <div className="btn-addproduct mb-4">
                <button type="button" className="btn btn-cancel me-2" onClick={goBack}>
                  {t?.[l]?.["cancel"] || "Cancel"}
                </button>
                <button type="submit" className="btn btn-submit">
                {t?.[l]?.["save"] || "Save"}
                </button>
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default AddProduct;